/* @flow */
/* eslint-disable babel/no-invalid-this */
import type { PanTiltFeature } from "./types";

export default function PanTilt(feature: PanTiltFeature) {
  let tiltUpAction = feature.actions.up;
  let tiltDownAction = feature.actions.down;
  let panLeftAction = feature.actions.left;
  let panRightAction = feature.actions.right;

  function panTiltError() {
    return new Error(
      "Attempted to use pan/tilt on a device with no associated action in its pan_tilt feature"
    );
  }

  this.tiltUp = () => {
    if (tiltUpAction == null) {
      return $.Deferred.reject(panTiltError());
    } else {
      return this.executeDeviceAction(
        tiltUpAction,
        {},
        { updateModelWithResponse: false }
      );
    }
  };

  this.tiltDown = () => {
    if (tiltDownAction == null) {
      return $.Deferred.reject(panTiltError());
    } else {
      return this.executeDeviceAction(
        tiltDownAction,
        {},
        { updateModelWithResponse: false }
      );
    }
  };

  this.panLeft = () => {
    if (panLeftAction == null) {
      return $.Deferred.reject(panTiltError());
    } else {
      return this.executeDeviceAction(
        panLeftAction,
        {},
        { updateModelWithResponse: false }
      );
    }
  };

  this.panRight = () => {
    if (panRightAction == null) {
      return $.Deferred.reject(panTiltError());
    } else {
      return this.executeDeviceAction(
        panRightAction,
        {},
        { updateModelWithResponse: false }
      );
    }
  };
}



// WEBPACK FOOTER //
// ./src/models/mixins/device_features/pan_tilt.js